var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-container',{staticClass:"pb-1 pt-5"},[_c('MainLogo'),_c('Search')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }